import React from "react";
import Header from "./header";
import Navigation from "./navigation";
import Dispatcher from "../dispatcher";
import UtilityStore from "../stores/utility-store";
import { createTheme, ThemeProvider } from "@vitalsource/vstui/themes";

export default class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      navigationOpen: UtilityStore.get(UtilityStore.HAMBURGER_STATE)
    };

    this._handleHamburgerToggle = this._handleHamburgerToggle.bind(this);
    this._localeChange = this._localeChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(
      Dispatcher.HEADER_HAMBURGER_CHANGE,
      this._handleHamburgerToggle
    );
    Dispatcher.on(Dispatcher.LOCALE_CHANGE, this._localeChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(
      Dispatcher.HEADER_HAMBURGER_CHANGE,
      this._handleHamburgerToggle
    );
    Dispatcher.removeListener(Dispatcher.LOCALE_CHANGE, this._localeChange);
  }

  _localeChange() {
    this.forceUpdate();
  }

  _handleHamburgerToggle() {
    this.setState({
      navigationOpen: UtilityStore.get(UtilityStore.HAMBURGER_STATE)
    });
  }

  render() {
    const theme = createTheme({ typography: { htmlFontSize: 10 } });
    return (
      <ThemeProvider theme={theme}>
        <div>
          <Header />
          <Navigation page={this.props.page} />
          <div
            id="content-right"
            className={classNames({
              "navigation-open": this.state.navigationOpen
            })}
          >
            {this.props.component}
          </div>
        </div>
      </ThemeProvider>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/layout.jsx
 **/